export default "__VITE_ASSET__pCA613WR__"